import React, { useState } from 'react';
import { connect } from 'react-redux';
import { GoogleProvider } from 'leaflet-geosearch';
import Geocode from "react-geocode";

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import StarIcon from '@material-ui/icons/Star';
import { Link } from 'react-router-dom';


import Input from '../../components/Input/Input';
import { createLocation } from '../../store/actions/location';
import Map from '../../components/Map/Map';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import { setMessage } from '../../store/actions/general';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
  map: {
    position: 'relative',
    zIndex: '1',
  },
  card: {
    position: 'absolute',
    backgroundColor: 'white',
    top: '90px',
    left: '20px',
    zIndex: '200',
    height: 'auto',
    width: '360px',
  },
  cardContent: {
    padding: '20px',
    paddingTop: '5px',
  },
  container: {
    position: 'relative',
  },
  button: {
    marginTop: '15px',
  },
  slider: {
    display: 'inline-block',
    backgroundColor: theme.palette.primary.contrastText,
    marginTop: '20px',
    width: '200px',
    height: '15px',
    borderRadius: '5px',
    color: theme.palette.primary.main,
    outline: 'none',
    opacity: '0.5',
    transition: 'opacity .2s',
    '-webkit-appearence': 'none',
  },
  sliderText: {
    display: 'inline-block',
    width: '110px',
    textAlign: 'left',
  },
});

class CreateLocation extends React.Component {
  state = {
    value: 0,
    address: '',
    addressSearch: '',
    modal: false,
    provider: new GoogleProvider({
      params: {
        key: 'AIzaSyAeaAPf9Ghck4OWSfBOFMOkn43PAJyj3Bs',
      },
    }),
    location: {
      address: '',
      description: '',
      lat: null,
      lng: null,
      range: '50',
    },
    searchLoading: false,
    addressPoint: '',
  };

  cadastrar = () => {
    // const validaetPremium = JSON.parse(localStorage.getItem('privileges')).isExportAfd;
    // if (validaetPremium) {
    this.props
      .onCreateLocation(this.state.location)
      .then(() => this.props.history.push('/locais'))
      .catch(error => error)

    // } else {
    //   this.setState({ modal: true });
    // }

  }
  closeModal = () => {
    this.setState({ modal: false });
  }

  handleAddress = (event) => {
    const newLocation = { ...this.state.location };
    newLocation.address = event.target.value;
    this.setState({ address: event.target.value });
    this.setState({ location: newLocation });
  };

  handleDescription = (event) => {
    const newLocation = { ...this.state.location };
    newLocation.description = event.target.value;
    this.setState({ location: newLocation });
  };

  handleRadius = (event) => {
    const newLocation = { ...this.state.location };
    newLocation.range = event.target.value;
    this.setState({ location: newLocation });
  };

  handleSearch = () => {
    this.setState({ searchLoading: true });
    const newLocation = { ...this.state.location };
    this.state.provider.search({ query: this.state.address }).then((result) => {
      if (result[0]) {
        newLocation.lat = result[0].y;
        newLocation.lng = result[0].x;
        this.setState({ location: newLocation });
        this.setState({ addressSearch: result[0].label });
        this.setState({ searchLoading: false });
      } else {
        this.setState({ searchLoading: false });
        this.props.onMessage('Endereço não encontrado');
      }
    });

  };

  handleAddressPoint = () => {
    Geocode.setApiKey("AIzaSyAeaAPf9Ghck4OWSfBOFMOkn43PAJyj3Bs");
    Geocode.fromLatLng(this.state.location.lat, this.state.location.lng).then(
      (response) => {
        const address = response.results[0].formatted_address;
        this.setState({ addressPoint: address });
        const newLocation = { ...this.state.location };
        newLocation.address = address;
        this.setState({ location: newLocation });
      },
      (error) => {
        console.error(error);
      }
    );
  };

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.handleSearch();
    }
  };

  handlePosition = (newPosition) => {
    const newLocation = { ...this.state.location };
    newLocation.lat = newPosition.lat;
    newLocation.lng = newPosition.lng;
    this.setState({ location: newLocation });
    this.setState({ address: '' });
    this.handleAddressPoint();
  };

  handleAddressValue = (event) => {
    const newAddress = event.target.value;
    this.setState({
      address: newAddress,
      addressPoint: newAddress, // atualiza o estado addressPoint com o novo valor
    });
  }

  render() {
    const zoom = this.state.location.lat !== null ? true: false
    const { classes, loading } = this.props;
    const { location, searchLoading, addressPoint } = this.state;


    return (
      <div className={classes.container}>
        <ContentHeader
          title="Cadastrar Local"
          subtitle="Informe o endereço para cadastrar o local desejado"
        />
        <div className={classes.map}>
          <Map
            position={location.lat !== null ? [location.lat, location.lng] : undefined}
            radius={Number(location.range)}
            handlePosition={this.handlePosition}
            zoomPosition={zoom}
          />
        </div>
        <Paper elevation={2} className={classes.card}>
          <div className={classes.cardContent}>
            <Tabs value={this.state.value} indicatorColor="primary" textColor="primary" centered>
              <Tab label="Mapa" />
            </Tabs>
            <Input
              elementType="input"
              value={location.description}
              onChange={this.handleDescription}
              type="text"
              label="Descrição"
              margin="normal"
              required
              fullWidth
            />
            <Input
              elementType="search"
              // value={this.state.address || this.state.addressPoint}
              onChange={(event) => {
                this.handleAddress(event);
                this.handleAddressValue(event);
              }}
              handleSearch={this.handleSearch}
              onKeyPress={this.handleKeyPress}
              loading={searchLoading}
              label="Buscar endereço"
              margin="normal"
              required
              fullWidth
            />

            {/* <Typography>{addressSearch}</Typography> */}
            {this.state.addressPoint || this.state.address !== '' ?
              (<Typography>Endereço completo: {addressPoint}</Typography>) : ""}

            <div style={{ display: 'inline-block' }}>
              <Typography variant="h6" color="primary" className={classes.sliderText}>
                Distância
              </Typography>

              <input
                type="range"
                min="10"
                max="1000"
                value={location.range}
                onChange={this.handleRadius}
                className={classes.slider}
                step="10"
              />

              <Typography align="right" color="textSecondary">{`${location.range}m`}</Typography>
            </div>

            <Button
              fullWidth
              type="submit"
              variant="contained"
              color="primary"
              onClick={this.cadastrar}
              className={classes.button}
              disabled={location.description === '' || loading}
            >
              {loading ? <CircularProgress size={20} color="primary" /> : 'CADASTRAR'}

            </Button>
          </div>
        </Paper>

        <Dialog
          open={this.state.modal}
          onClose={modal => this.closeModal()}
          // onClose={modal => this.closeModal('openAdd')}
          aria-labelledby="form-dialog-title"
          style={{ display: 'flex', flexDirection: 'column' }}
          fullWidth
          maxWidth="sm"
          titleStyle={{ textAlign: "center" }}
        >
          <DialogTitle >Seja premium e cadastre locais e cerca virtual.
          </DialogTitle>
          <DialogContent>
            <IconButton
              style={{ position: "absolute", top: "0", right: "0" }}
              onClick={() => this.closeModal()}
            >
              <CloseIcon />
            </IconButton>


            <DialogContentText style={{ fontSize: '14px', color: '#2880ca', right: '20px', bottom: '-15px', position: '' }}>
              <p>Com a <b>cerca virtual</b> você pode delimitar o local de trabalho dos seus funcionários
                e qualquer ponto registrado fora dessa área será alertado através da central de atividades.</p>
            </DialogContentText>

          </DialogContent>
          <Button variant="contained"
            color="primary"
            component={Link}
            to='/assinatura'>
            <StarIcon /> CLIQUE AQUI E ASSINE AGORA! <StarIcon />
          </Button>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  locations: state.location.locations,
});

const mapDispatchToProps = dispatch => ({
  onCreateLocation: location => dispatch(createLocation(location)),
  onMessage: message => dispatch(setMessage(message)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(CreateLocation));
